<template>
  <div>
    <v-data-table
      v-model="selectedItems"
      v-model:options="pagination"
      :headers="headers"
      :items="parts"
      :server-items-length="totalItems"
      :items-per-page-options="[5, 10]"
      item-key="_id"
      show-select
      :loading="loading"
      class="elevation-1 nowrap-headers"
      :footer-props="{
        'items-per-page-options': [5, 10, 25, 50],
        'items-per-page-text': 'Rows per page',
      }"
      @update:options="''"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #body="{ items }">
        <tr
          v-for="(item, index) in items"
          :key="item._id"
          class="tableRowColor"
        >
          <!----------------------------------------SELECTION---------------------------------------->
          <td>
            <v-row class="justify-center">
              <v-checkbox
                v-model="item.selected"
                class="mt-2"
                color="primary"
                hide-details
              />
            </v-row>
          </td>
          <!-------------------------------------------ID-------------------------------------------->
          <!--OLD ID-->
          <td v-if="item.old_id && item.old_id !== undefined">
            <v-row class="pointer ma-1 text-center justify-center d-block">
              <qr-code
                class="d-flex justify-center"
                :size="60"
                :text="item.old_id"
              />
              {{
                item.old_id.slice(item.old_id.length - 6, item.old_id.length)
              }}
            </v-row>
          </td>
          <!--NEW ID-->
          <td v-else>
            <v-row class="d-flex flex-column justify-center ma-1">
              <qr-code :size="60" :text="item._id" />
              {{ item._id.slice(item._id.length - 6, item._id.length) }}
            </v-row>
          </td>
          <!-----------------------------------------ACTIONS----------------------------------------->
          <td>
            <v-row row align-center>
              <!--DETAILS-->
              <v-btn icon @click="details(item)">
                <v-icon color="grey-darken-2"> view_list </v-icon>
              </v-btn>
            </v-row>
          </td>
          <!------------------------------------------GROUP------------------------------------------>
          <td>
            <v-row class="d-flex flex-column">
              <v-col>
                <span
                  v-if="
                    item.infoCar &&
                    item.infoCar.description &&
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.category
                  "
                  class="text-xs font-weight-bold"
                >
                  <!-- eslint-disable-next-line max-len -->
                  {{
                    item.infoCar.description.descriptionId.category[
                      $store.getters.language
                    ]
                  }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!------------------------------------------TITLE------------------------------------------>
          <td class="text-xs">
            <v-row class="d-flex flex-column">
              <v-col v-if="item.infoCar && item.infoCar.description">
                <span
                  v-if="
                    item.infoCar.description.descriptionId &&
                    item.infoCar.description.descriptionId.title
                  "
                  class="text-xs font-weight-bold"
                >
                  {{
                    item.infoCar.description.descriptionId.title[
                      $store.getters.language
                    ]
                  }}
                </span>
                <span
                  v-if="item.infoCar.description.positionCode"
                  class="text-xs"
                >
                  {{ getPosition(item.infoCar.description.positionCode) }}
                </span>
              </v-col>
            </v-row>
          </td>
          <!------------------------------------MANUFACTURER CODE------------------------------------>
          <td class="text-xs">
            {{ item.manufacturer_code }}
          </td>
          <!-----------------------------------------IMAGES------------------------------------------>
          <td>
            <v-row class="justify-center">
              <img
                :src="
                  item.images && item.images.length > 0 && item.images[0].thumb
                    ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`
                    : `https://portal.lekotech.com/logo_small.png`
                "
                class="ma-1 pointer"
                height="75"
                width="100"
                @click="showImages(item._id, item.images, item.date_created)"
              />
            </v-row>
          </td>
          <!------------------------------------------NOTES------------------------------------------>
          <td>
            <v-row
              class="pointer ml-3 mr-2"
              style="min-width: 125px !important"
              @click="showNotes(item.notes)"
            >
              <span v-if="item.notes && item.notes.length > 40">
                {{ item.notes.substring(0, 40) }}...<v-icon>
                  visibility
                </v-icon>
              </span>
              <span v-else> {{ item.notes }} </span>
              {{ item.notes ? "(" + item.notes.length + ")" : "" }}
            </v-row>
          </td>
          <!------------------------------------------PRICE------------------------------------------>
          <td class="text-xs">{{ item.price }} {{ item.currency }}</td>
          <!----------------------------------------LOCATION----------------------------------------->
          <td v-if="item.shelf_data" class="text-xs">
            {{ item.shelf_data.repo }} {{ item.shelf_data.shelf.room_name }} -
            {{ item.shelf_data.shelf.location_code }}:
            {{ item.shelf_data.shelf.x }},
            {{ item.shelf_data.shelf.y }}
          </td>
          <td v-else class="text-xs">-</td>
          <!-----------------------------------------QUALITY----------------------------------------->
          <td>
            <div style="width: 150px">
              <v-rating
                v-if="item.quality"
                :value="item.quality.rating"
                color="red"
                background-color="red-darken-4"
                readonly
                size="12"
              />
              <v-rating
                v-else
                :value="0"
                color="red"
                background-color="red-darken-4"
                readonly
                size="12"
              />
            </div>
          </td>
          <!------------------------------------------DATE------------------------------------------->
          <td style="min-width: 170px" class="justify-center pl-2">
            {{ formatDate(item.date_created) }}
          </td>
          <!-----------------------------------------STATUS------------------------------------------>
          <td>
            <v-row class="justify-center mr-4">
              <v-btn v-if="item.status === 1" small color="success" outlined>
                {{ $t("parts.status.entered") }}
              </v-btn>
              <v-btn v-if="item.status === 2" small color="error" outlined>
                {{ $t("parts.status.returned") }}
              </v-btn>
              <v-btn v-if="item.status === 2.1" small color="error" outlined>
                {{ $t("parts.status.returned_shop") }}
              </v-btn>
              <v-btn v-if="item.status === 3" small color="info" outlined>
                {{ $t("parts.status.re_entered") }}
              </v-btn>
              <v-btn v-if="item.status === 4" small color="info" outlined>
                {{ $t("parts.status.found") }}
              </v-btn>
            </v-row>
          </td>
          <!----------------------------------------------------------------------------------------->
        </tr>
        <tr v-if="parts && parts.length < 1">
          <td :colspan="headers.length" class="text-center pa-4">
            <v-alert type="info" border="left" color="red lighten-2" text>
              No data available.
            </v-alert>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="notesDialog" width="250">
      <v-card flat>
        <v-card-text>
          {{ notesShow }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import VueQrCode from "vue-qr-generator";

import getRequest from "../../../api/getRequest";

export default {
  components: {
    "qr-code": VueQrCode,
  },
  props: {
    search: {
      type: Object,
      default: null,
    },
    selected: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    selectedItems: [],
    totalItems: 0,
    parts: [],
    headers: [
      {
        text: "QR Code",
        sortable: true,
        value: "_id",
      },
      {
        text: "Actions",
        sortable: false,
        value: "",
      },
      {
        text: "Group",
        sortable: true,
        value: "group",
      },
      {
        text: "Title",
        sortable: true,
        value: "title",
      },
      {
        text: "Manufacturer Code",
        sortable: false,
        value: "manufacturer_code",
      },
      {
        text: "Images",
        sortable: false,
        value: "",
      },
      {
        text: "Notes",
        sortable: false,
        value: "notes",
      },
      {
        text: "Price",
        sortable: true,
        value: "price",
      },
      {
        text: "Location",
        sortable: true,
        value: "shelf_data.shelf.room_name",
      },
      {
        text: "Quality",
        sortable: true,
        value: "quality",
      },
      {
        text: "Date Created",
        sortable: true,
        value: "date",
      },
      {
        text: "Status",
        sortable: true,
        value: "status",
      },
    ],
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["date_created"],
      sortDesc: true,
    },
    notesDialog: false,
    notesShow: "",
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    searchObject() {
      return this.$props.search;
    },
  },
  watch: {
    searchObject(value) {
      if (!value || !value.type) this.getParts();
      else this.searchMethod(value);
    },
    selectedItems(value) {
      this.$emit("select", value);
    },
    pagination: {
      handler() {
        if (!this.searchObject || !this.searchObject.type) {
          this.getParts();
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(
            this.searchObject.searchField,
            this.searchObject.advancedSearchFields,
          );
        } else if (this.searchObject.type === "idOnly") {
          this.searchById(this.searchObject.searchField);
        } else {
          //
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getLocale();
    this.getParts();
    this.selectedItems = this.$props.selected ? this.$props.selected : [];
  },
  methods: {
    getLocale() {
      this.headers[0].text = this.$t("reservations.parts.datatable.qr_code");
      this.headers[1].text = this.$t("reservations.parts.datatable.actions");
      this.headers[2].text = this.$t("reservations.parts.datatable.group");
      this.headers[3].text = this.$t("reservations.parts.datatable.title");
      this.headers[4].text = this.$t(
        "reservations.parts.datatable.manufacturer_code",
      );
      this.headers[5].text = this.$t("reservations.parts.datatable.images");
      this.headers[6].text = this.$t("reservations.parts.datatable.notes");
      this.headers[7].text = this.$t("reservations.parts.datatable.price");
      this.headers[8].text = this.$t("reservations.parts.datatable.location");
      this.headers[9].text = this.$t("reservations.parts.datatable.quality");
      this.headers[10].text = this.$t(
        "reservations.parts.datatable.date_created",
      );
      this.headers[11].text = this.$t("reservations.parts.datatable.status");
    },
    getParts() {
      this.loading = true;
      getRequest(
        "/part/inventory/datatable",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${
          this.pagination.groupBy
        }&descending=${this.paginationsortDesc}`,
      )
        .then((response) => {
          this.totalItems = response.count;
          this.parts = response.parts;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    searchMethod(data) {
      this.loading = true;
      getRequest(
        "/part/inventory/search/advanced",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${this.pagination.groupBy}&descending=${
          this.paginationsortDesc
        }&search_field=${data.searchField}&language=${
          this.$store.getters.language
        }&title_code=${data.titleCode}&type=${data.type}&brand=${
          data.advancedSearchFields.brand
        }&model=${data.advancedSearchFields.model}&version=${
          data.advancedSearchFields.version
        }&institution=${data.advancedSearchFields.institution}&shipment=${
          data.advancedSearchFields.shipment
        }&status=${data.advancedSearchFields.status}&quality=${
          data.advancedSearchFields.quality
        }&price=${data.advancedSearchFields.price}&start_date=${
          data.advancedSearchFields.startDate
        }&end_date=${data.advancedSearchFields.endDate}`,
      )
        .then((response) => {
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    showImages() {},
    details(data) {
      this.$emit("details", data);
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
    showNotes(notes) {
      this.notesDialog = true;
      this.notesShow = notes;
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
  },
};
</script>
